import { render, staticRenderFns } from "./HomeInfo.vue?vue&type=template&id=0fe4bdcc&"
import script from "./HomeInfo.vue?vue&type=script&lang=js&"
export * from "./HomeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports